$(function(){
    let mediaQuery = matchMedia('(min-width: 1008px)');
    let $stcybtn_pos = $('.cc_sticky_btn_position');
    let $stcybtn = $('.cc_sticky_btn');
    let $win = $(window);
  
    var product_info_wrap = 0;
    $win.on('load resize', function(){
      setTimeout(function(){
        product_info_wrap = $(".tk_tab_group_wrap").offset().top;
      },1000);
    });

    //$win.scroll(function (){
    $win.on('load scroll resize', function(){
      let scroll = $win.scrollTop(); //スクロール量
      let stcybtn_pos_height = $stcybtn_pos.height();
    
        //カゴ周りエリア外にいる時
        if ( scroll > product_info_wrap ) {
          $stcybtn.css({
            "position":"fixed",
            "border-top":"1px solid #c7c7c7",
            "padding": "10px 14px"
            });
          $stcybtn_pos.height(stcybtn_pos_height);
        }
        //カゴ周りエリア内にいる時
        else {
          $stcybtn.css({
            "position":"relative",
            "border-top":"none",
            "padding":"0 0 10px",
            });
          $stcybtn_pos.height('auto');
        }
    });
  });